
import React from 'react';
import { User, Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface SidebarHeaderProps {
  user: User;
  isRtl: boolean;
  language: Language;
  onNewChat: () => void;
  onClose: () => void;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ user, isRtl, language, onNewChat, onClose }) => {
  const t = TRANSLATIONS[language];
  
  const getRoleBadge = () => {
    const role = user.role || 'user';
    const styles = {
      user: { label: t.role_user, color: 'text-slate-400 bg-slate-400/10' },
      admin: { label: t.role_admin, color: 'text-blue-500 bg-blue-500/10' },
      super: { label: t.role_super, color: 'text-purple-500 bg-purple-500/10' },
      superadmin: { label: t.role_superadmin, color: 'text-emerald-500 bg-emerald-500/10' }
    };
    const current = styles[role as keyof typeof styles] || styles.user;
    
    return (
      <span className={`text-[8px] font-black tracking-widest uppercase px-1.5 py-0.5 rounded-md ${current.color}`}>
        {current.label}
      </span>
    );
  };

  return (
    <div className="p-5 lg:p-6 border-b border-slate-50 dark:border-white/5">
      <br/>
      <div className="flex items-center gap-3 mb-6 lg:mb-8">
         <div className="w-10 h-10 rounded-xl bg-emerald-500 flex-shrink-0 flex items-center justify-center text-white text-[14px] font-black overflow-hidden border border-emerald-400/20 shadow-lg shadow-emerald-500/10">
            {user.avatar ? <img src={user.avatar} className="w-full h-full object-cover" alt="User" /> : user.name?.charAt(0)}
         </div>
         <div className="flex-1 min-w-0">
            <p className="text-xs font-black text-slate-800 dark:text-white truncate mb-0.5">{user.name || (isRtl ? 'مستخدم' : 'User')}</p>
            <div className="flex items-center gap-2">
               {getRoleBadge()}
               <div className="w-1 h-1 rounded-full bg-slate-300 dark:bg-white/20"></div>
               <p className="text-[8px] text-slate-400 font-bold uppercase tracking-widest">{user.plan === 'pro' ? (isRtl ? 'برو' : 'PRO') : (isRtl ? 'أساسي' : 'BASIC')}</p>
            </div>
         </div>
         <button onClick={onClose} className="lg:hidden w-8 h-8 flex items-center justify-center text-slate-400 hover:bg-slate-50 dark:hover:bg-white/5 rounded-lg transition-all">
           <i className={`fas fa-chevron-${isRtl ? 'right' : 'left'}`}></i>
         </button>
      </div>
      
      <button 
        onClick={onNewChat}
        className="w-full flex items-center justify-center gap-3 bg-emerald-500 hover:bg-emerald-600 text-white font-black py-3.5 lg:py-4 rounded-xl lg:rounded-[18px] text-[11px] transition-all shadow-lg shadow-emerald-500/10 active:scale-95"
      >
        <i className="fas fa-plus"></i>
        {t.newChat}
      </button>
    </div>
  );
};
export default SidebarHeader;
